const PATH = {
  WEB_PATH: ""
};

function setWebPath(params) {
  PATH.WEB_PATH = params;
}
//登录
function setLoginPath(productId, appId) {
  PATH.LOGIN_URL = `${PATH.WEB_PATH}/api/${productId}/${appId}/userLogin`;
}
//验证码
function setValidatePath(productId, appId) {
  PATH.USER_AUTH_VILIDATA = `${PATH.WEB_PATH}/api/${productId}/${appId}/`;
}
//注册
function setRegistPath(productId, appId) {
  PATH.USER_AUTH_REGIST = `${PATH.WEB_PATH}/api/${productId}/${appId}/`;
}
//检查手机号是否已经注册
function setResgistPhonePath(productId, appId, webUserId, webUserToken) {
  PATH.USER_AUTH_REGIST_PHONE = `${PATH.WEB_PATH}/api/${productId}/${appId}/${webUserId}/${webUserToken}/dispatcher/257/256/`;
}
//检查收集验证码是否正确
function setCheckVerifyCodePath(productId, appId, webUserId, webUserToken) {
  PATH.USER_AUTH_CHECK_VERIFY_CODE = `${PATH.WEB_PATH}/api/${productId}/${appId}/${webUserId}/${webUserToken}/dispatcher/257/256/`;
}
//刷新token
function webRefreshToken(
  productId,
  appId,
  userId,
  userRefreshToken,
  webRefreshToken
) {
  // userRefreshToken 后台需要的是常量所以不用取变量的值
  PATH.USER_AUTH_REFRESHTOKEN = `${PATH.WEB_PATH}/api/${productId}/${appId}/${userId}/userRefreshToken/${webRefreshToken}`;
}
//验证token
function userVerifyToken(productId, appId, userId, webUserToken) {
  PATH.USER_AUTH_VERIFYTOKEN = `${PATH.WEB_PATH}/api/${productId}/${appId}/${userId}/${webUserToken}/userVerifyToken`;
}
//页面接口
function webServiceInterface(productId, appId, userId, webUserToken) {
  PATH.USER_AUTH_SERVICEINTERFACE = `${PATH.WEB_PATH}/api/${productId}/${appId}/${userId}/${webUserToken}/dispatcher/96/256/`;
  PATH.UPLOAD_IMG_SERVICEINTERFACE = `${PATH.WEB_PATH}/api/${productId}/${appId}/${userId}/${webUserToken}/dispatcher/278/256/`;
  PATH.WORD_FILTER_SERVICEINTERFACE = `${PATH.WEB_PATH}/api/${productId}/${appId}/${userId}/${webUserToken}/dispatcher/105/256/`;
}
//用户信息接口
function userInformatin(productId, appId, userId, webUserToken) {
  PATH.USER_AUTH_USERINFORMATION = `${PATH.WEB_PATH}/api/${productId}/${appId}/${userId}/${webUserToken}/dispatcher/257/256/`;
}

//用户行为
function userBehavior(productId, appId, userId, webUserToken) {
  PATH.USER_BEHAVIOR = `${PATH.WEB_PATH}/api/${productId}/${appId}/${userId}/${webUserToken}/dispatcher/17/256/`;
  //检索服务
  PATH.TRAVEL_SEARCH = `${PATH.WEB_PATH}/api/${productId}/${appId}/${userId}/${webUserToken}/dispatcher/96/256/`;
}

function setPath(productId, appId) {
  setLoginPath(productId, appId);
  setValidatePath(productId, appId);
  setRegistPath(productId, appId);
  setResgistPhonePath(productId, appId, "noUser", "noTaken");
  setCheckVerifyCodePath(productId, appId, "noUser", "noTaken");
}

//PATH.USER_AUTH_UPLOAD_URL = `${COMMONURL + userId}/formDispatcher/257/256/`;
export default {
  PATH,
  setRegistPath,
  setValidatePath,
  setLoginPath,
  webRefreshToken,
  userVerifyToken,
  setPath,
  setWebPath,
  webServiceInterface,
  userInformatin,
  userBehavior
};
